import { handleActions } from "redux-actions";
import { createRoutine } from "redux-saga-routines";

export const fetchInsiderAnalysisCategories = createRoutine(
  "app/analysisCategories/FETCH_INSIDER_ANALYSIS_CATEGORIES"
);

const initialState = {
  data: [],
  error: null,
  loading: null
};

export default handleActions(
  {
    [fetchInsiderAnalysisCategories.TRIGGER]: state => ({
      ...state,
      loading: true
    }),
    [fetchInsiderAnalysisCategories.FAILURE]: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload
    }),
    [fetchInsiderAnalysisCategories.SUCCESS]: (state, { payload }) => ({
      ...state,
      loading: false,
      data: payload
    })
  },
  initialState
);
